import styled from 'styled-components';
import AntdModal from '../../../AntdModal';

const StyledAddPaymentModal = styled(AntdModal)`
  .ant-form-item {
    .ant-dropdown-trigger {
      .ant-input.ant-input-lg:not(.ant-dropdown-trigger) {
        height: unset;
        padding-left: 0;
      }
    }
  }
`;

export {
  StyledAddPaymentModal,
};
